/*
 * File: CaretSpinIcon.tsx
 * Project: beaker
 * -----
 * Last Modified: 24 May 2022 10:20:22 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { CaretRightOutlined } from '@ant-design/icons';
import React, { FC, useEffect } from 'react';
import { animated, useSpring } from 'react-spring';

interface Props {
  isOpen: boolean;
}

export const CaretSpinIcon: FC<Props> = ({ isOpen }) => {
  const [styles, api] = useSpring(() => ({
    from: {
      rotate: 0
    }
  }));

  useEffect(() => {
    if (isOpen) {
      api.start({ to: { rotate: 90 } });
    } else {
      api.start({ to: { rotate: 0 } });
    }
  }, [api, isOpen]);

  return (
    <animated.span style={{ ...styles, ...{ marginRight: 5 } }}>
      <CaretRightOutlined style={{ paddingTop: 5 }} />
    </animated.span>
  );
};
